import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../../config/api";
import Helpers, { number_format } from "../../../../../config/Helpers";
import axios from "axios";

const postUrlLogin  = API_URL + "widgets";

class Revenue extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            result_rows     : (<div></div>),
            total_widgets   : { 
                revenue_by_widget_ly : 0, 
                revenue_by_widget : 0, 
                revenue_budget_by_widget : 0,
                revenue_bb_by_widget : 0 
            }
        }
    }
    activeWdg(type){
        this.props.activeWidget(type)
    }

    componentWillReceiveProps(props){
        const
            has_statics_channels  = (Object.keys(props.statics_channels).length > 0),
            has_statics_segments  = (Object.keys(props.statics_segments).length > 0),
            has_statics_trimester = (Object.keys(props.statics_trimester).length > 0),
            has_statics_time      = (Object.keys(props.statics).length > 0),
            has_totals_channels   = (Object.keys(props.total_widgets_channels).length > 0)

        let wdg_aux = [], totals_general = "";

        /*if(has_totals_channels){
            this.state.total_widgets = this.props.total_widgets_channels;
        }else{
            this.state.total_widgets = this.props.total_widgets;
        }*/
        wdg_aux["channels"] = props.statics_channels; 
        wdg_aux["segments"] = props.statics_segments; 
        wdg_aux["trimester"] = props.statics_trimester; 
        wdg_aux["months"] = props.statics; 
        
        this.state.totals_general = (<div className={"datagrid-month totals"}>
                            <div>${ number_format(this.state.total_widgets.revenue_by_widget_ly)}</div>
                            <div>${ number_format(this.state.total_widgets.revenue_by_widget)}</div>
                            <div>${ number_format(this.state.total_widgets.revenue_budget_by_widget)}</div>
                            <div>{props.filter_by_pace === 0 ? number_format(this.state.total_widgets.revenue_bb_by_widget, 2) : number_format(this.state.total_widgets.revenue_by_widget_pace, 2) }%</div>
                        </div>);

        if(Object.keys(wdg_aux).length > 0){
            let key_times = props.layout.state.segmentActive;
            let key_times_aux = this.props.app._LayoutReview.state.key_time;
            this.state.result_rows = Object.keys(props.statics).map((filt, index) => {
                if(has_statics_channels){
                    if((wdg_aux["channels"][filt] !== undefined) && (key_times_aux[filt] !== undefined)){
                        const wdg = wdg_aux["channels"][filt];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            if(filt_aux !== "totals"){
                                //if(wdg[filt_aux].num_reservations !== 0){
                                    let channel_list = wdg[filt_aux];
                                    if(key_times[filt_aux] !== undefined){
                                        return Object.keys(channel_list).map((filt_channel, index_channel) => {
                                            const totals_class = (filt === "all" ? " totals" : "");
                                            return this.getRow(channel_list, filt_channel, index_aux, true, totals_class)
                                        })
                                    }else{
                                        const totals_class = (filt === "all" ? " totals" : "");
                                        return this.getRow(wdg[filt_aux], "totals", index_aux, false, totals_class)
                                    }
                               // }
                            }else{
                                const totals_class = (filt === "all" ? " totals" : "");
                                return this.getRow(wdg, filt_aux, index_aux, true, totals_class)
                            }
                        })
                    }
                }   
                if(has_statics_segments){
                    if((wdg_aux["segments"][filt]['segments'] !== undefined) && (key_times_aux[filt] !== undefined)){
                        const wdg = wdg_aux["segments"][filt]["segments"];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            //if(wdg[filt_aux].num_reservations !== 0){
                            const totals_class = (filt === "all" ? " totals" : "");
                            return this.getRow(wdg, filt_aux, index_aux, true, totals_class)
                           //}
                        })
                    }
                }
                if(has_statics_time){
                    const totals_class = (filt === "all" ? " totals" : "");
                    //if(wdg_aux["months"][filt].num_reservations !== 0){
                        return this.getRow(wdg_aux["months"], filt, index, true, totals_class)
                   // }
                }
            })
        }
        this.setState({ total_widgets : this.props.total_widgets });
    }
    getRow(wdg_aux, filt, index, title = true, totals_class = ""){
        return filt !== "totals" ? 
            <div key={"list-room-revenue-"+index} className={ (index%2 ? "row-c" : "") + totals_class }>
                <div>${ number_format(wdg_aux[filt].total_reservations_ly) }</div>
                <div>${ number_format(wdg_aux[filt].total_reservations) }</div>
                <div>${ number_format(wdg_aux[filt].budget_revenue) }</div>
                <div>{ this.props.filter_by_pace === 0 ? number_format(wdg_aux[filt].book_vs_budget_revenue, 2) : number_format(wdg_aux[filt].revenue_pace, 2) }%</div>
            </div>
        : <div key={"list-room-revenue-"+index} className={"datagrid-month " + (title === true ? "totals" : (index%2 ? "row-c" : "")) + totals_class }>
            <div>${ number_format(wdg_aux[filt].revenue_by_widget_ly) }</div>
            <div>${ number_format(wdg_aux[filt].revenue_by_widget) }</div>
            <div>${ number_format(wdg_aux[filt].revenue_budget_by_widget) }</div>
            <div>{this.props.filter_by_pace === 0 ? number_format(wdg_aux[filt].revenue_bb_by_widget, 2) : number_format(wdg_aux[filt].revenue_by_widget_pace, 2) }%</div>
        </div>
    }

    render(){
        
        return (
            <div className={"datagrid-widget revenue "+ this.props.hidden_wdg_revenue}>
                <div className="container-fluid">
                    <div className="row header-widget">
                        <div className="col-md-12 options-widget">
                            <span className="title">REVENUE</span>
                            
                            <span className="opt remove-widget" onClick={this.activeWdg.bind(this, "revenue")}>
                                <img src={DeleteFilter} />
                            </span>
                        </div>
                    </div>
                    <div className="current-values">
                        <div className="row">
                            <div className="col-md-12 head-current">
                                <span>{this.props.app.state.past_year}</span>
                                <span>{this.props.app.state.current_year}</span>
                                <span>BUDGET</span>
                                <span>BOOK vs. <br />{this.props.filter_by_pace === 0 ? "BUDGET" : this.props.app.state.past_year}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 datagrid-list">
                                { this.state.result_rows }
                                {/* { this.state.totals_general } */}
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        )
    }
}

export default Revenue



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/views/Review/Revenue.js